module.exports = __webpack_public_path__ + "img/harenberg.125e4eaf.gif";